import i18n from '@/locales/init';
export const UNANSWERED = i18n.t('common.dauyan_no_answer'); 
export const UNANSWEREDWRAP = `'(${i18n.t('common.dauyan_no_answer')})'`;